import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Spin } from 'antd';
import type { CurrentUser } from '@mori/contracts';
import { lazy, Suspense, useEffect, useState } from 'react';
import { api } from './api';
import { LoginPage } from './pages/LoginPage';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp').then((module) => ({ default: module.AuthenticatedApp })));

export default function App() {
  const [autoLogin, setAutoLogin] = useState(true);
  const queryClient = useQueryClient(); const { data, isLoading } = useQuery({ queryKey: ['me'], queryFn: () => api<{ user: CurrentUser }>('/auth/me'), retry: false });
  const user = data?.user;
  const setUser = (next?: CurrentUser) => { void queryClient.cancelQueries(); queryClient.removeQueries({ predicate: query => query.queryKey[0] !== 'me' }); queryClient.setQueryData(['me'], { user: next }); };
  useEffect(() => { const expired = () => setUser(); window.addEventListener('eam-session-expired', expired); return () => window.removeEventListener('eam-session-expired', expired); }, [queryClient]);
  if (isLoading && !user) return <div className="boot-screen"><Spin size="large"/><span>正在进入墨睿科技EAM系统</span></div>;
  if (!user) return <LoginPage autoLogin={autoLogin} onLogin={(next) => setUser(next)}/>;
  return <Suspense fallback={<div className="boot-screen"><Spin size="large"/><span>正在加载管理工作台</span></div>}><AuthenticatedApp user={user} setUser={(next) => { if (!next) setAutoLogin(false); setUser(next); }}/></Suspense>;
}
